<template>
  <b-card title="POB">
    <pob-filter @filtersUpdated="filtersChangeHandler" />
    <pob-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import PobList from '@/components/Sales/Pob/PobList.vue'
import PobFilter from '@/components/Sales/Pob/PobFilter.vue'
import dateMixin from '@/mixins/dateMixin'

export default {
  components: {
    BCard,
    PobList,
    PobFilter,
  },
  mixins: [dateMixin],
  data() {
    return {
      filters: { pob_status: ['pending'] },
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
